var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.$.chart, _vm.$.chart_by_status] }, [
    _c(
      "div",
      { class: _vm.$.header },
      [
        _c("div", { class: _vm.$.title }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.locales("chart_" + _vm.chart.key + "_title")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.statusSwitch
          ? _c("vgp-switch", {
              attrs: { "is-toggle-on": _vm.chart.status },
              on: {
                onChange: function ($event) {
                  return _vm.$emit("onToggleStatus")
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.description
      ? _c("div", { class: _vm.$.description }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.locales("chart_" + _vm.chart.key + "_description")) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$.wrapper },
      [
        _c("doughnut-chart", {
          class: _vm.$.body,
          attrs: {
            id: _vm.chart.key,
            items: _vm.items,
            tooltipTitle: _vm.tooltipTitle,
            static: _vm.static,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { class: [_vm.$.footer, _vm.isShowStub ? _vm.$.invisible : ""] },
          _vm._l(_vm.summary, function (item) {
            return _c("div", { class: _vm.$.item }, [
              _c("div", { class: _vm.$.label }, [
                _vm._v("\n          " + _vm._s(item.text) + "\n        "),
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.$.value }, [
                _vm._v("\n          " + _vm._s(item.value) + "\n        "),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm.isShowStub
          ? _c("div", { class: _vm.$.stub }, [
              _c("div", { class: _vm.$.stub_item }),
              _vm._v(" "),
              _c("div", { class: _vm.$.stub_item }),
              _vm._v(" "),
              _c("div", { class: _vm.$.stub_text }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.locales("chart_" + _vm.chart.key + "_stub_text")
                    ) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("loader", { attrs: { show: _vm.isShowLoader } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }